import { render, staticRenderFns } from "./inventoryByProductCategory.vue?vue&type=template&id=10b8e340&"
import script from "./inventoryByProductCategory.vue?vue&type=script&lang=js&"
export * from "./inventoryByProductCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports